import type { LandingLocale } from './content/landingContentTypes.js';
import { landingLocalizedUrl } from './landingDocumentUrl.js';

export const landingWebPageSchema = (
  canonicalUrl: string,
  title: string,
  description: string,
  locale: LandingLocale,
  path: string,
) => ({
  '@type': path === '/kontakt' ? 'ContactPage' : ['/ueber-vivaporta', '/team'].includes(path) ? 'AboutPage' : 'WebPage',
  '@id': `${canonicalUrl}#webpage`,
  url: canonicalUrl,
  name: title,
  description,
  inLanguage: locale === 'en' ? 'en-US' : locale === 'tr' ? 'tr-TR' : 'de-DE',
  isPartOf: { '@id': `${new URL(canonicalUrl).origin}/#website` },
  about: { '@id': `${new URL(canonicalUrl).origin}/#organization` },
});

export const landingBreadcrumbSchema = (canonicalUrl: string, title: string, locale: LandingLocale, path: string) => {
  if (path === '/') return null;
  return {
    '@type': 'BreadcrumbList',
    '@id': `${canonicalUrl}#breadcrumb`,
    itemListElement: [
      {
        '@type': 'ListItem', position: 1, name: locale === 'en' ? 'Home' : locale === 'tr' ? 'Ana sayfa' : 'Startseite',
        item: landingLocalizedUrl(new URL(canonicalUrl).origin, '/', locale),
      },
      { '@type': 'ListItem', position: 2, name: title.replace(/\s*\|.*$/u, ''), item: canonicalUrl },
    ],
  };
};
